var map = {
	"./auth.store.js": "./src/store/modules/auth.store.js",
	"./catalogs.store.js": "./src/store/modules/catalogs.store.js",
	"./changelog.store.js": "./src/store/modules/changelog.store.js",
	"./channels.store.js": "./src/store/modules/channels.store.js",
	"./contacts.store.js": "./src/store/modules/contacts.store.js",
	"./cronjobs.store.js": "./src/store/modules/cronjobs.store.js",
	"./entities.store.js": "./src/store/modules/entities.store.js",
	"./entries.store.js": "./src/store/modules/entries.store.js",
	"./entrytypes.store.js": "./src/store/modules/entrytypes.store.js",
	"./general.store.js": "./src/store/modules/general.store.js",
	"./groups.store.js": "./src/store/modules/groups.store.js",
	"./imports.store.js": "./src/store/modules/imports.store.js",
	"./notifications.store.js": "./src/store/modules/notifications.store.js",
	"./printsettings.store.js": "./src/store/modules/printsettings.store.js",
	"./projects.store.js": "./src/store/modules/projects.store.js",
	"./properties.store.js": "./src/store/modules/properties.store.js",
	"./roles.store.js": "./src/store/modules/roles.store.js",
	"./system-config.store.js": "./src/store/modules/system-config.store.js",
	"./templates.store.js": "./src/store/modules/templates.store.js",
	"./user.store.js": "./src/store/modules/user.store.js",
	"./users.store.js": "./src/store/modules/users.store.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/store/modules sync \\.store\\.js$";